import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.order-planning-configuration')
  .factory('ProcessTrackingAPI', ProcessTrackingAPI);

function ProcessTrackingAPI(): BringozApi {
  return {
    base: `/processTracking/customRouteOrders`,
    infiniteScroll: {
      address: `/processTracking/customRouteOrders`,
      cmd: 'GET'
    },
    actions : {
    }
  }
}
